import React from 'react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { Box, Container, Typography, Link } from '@mui/material';
import { useStyles } from './styles';
import { LandingPageContextEnum } from 'enums';
import EmailFormVariant from 'components/EmailFormVariant';

export default function Header() {
  const classes = useStyles();
  const router = useRouter();

  return (
    <Box pt={8} pb={45}>
      <Container>
        <div className={classes.root}>
          <div>
            <Typography variant="h4">
              <b>
                The Best Biorender <br />
                Alternatives to <br />
                Communicate Science
              </b>
            </Typography>

            <Box my={4}>
              <Typography>
                <b>
                  Connect more people to your work with <br />
                  a more diverse, easy-to-use, and cheaper <br />
                  Biorender alternative.
                </b>
              </Typography>
            </Box>

            <EmailFormVariant
              buttonLoggedColor="default"
              buttonColor="primary"
              context={LandingPageContextEnum.CREATE_GRAPHICAL_ABSTRACT}
              textButtonLogged="Start Creating Now"
              labelColor="white"
              textAgreeColor="white"
            />
          </div>

          <div>
            <NextLink
              href={`/auth/login-register?from_url=${router.basePath + router.asPath}`}
              passHref={true}
            >
              <Link underline="hover">
                <img
                  src="/images/biorender-alternative-header.svg"
                  alt="Biorender alternative header"
                />
              </Link>
            </NextLink>
          </div>
        </div>
      </Container>
    </Box>
  );
}
